// extracted by mini-css-extract-plugin
export default {"page":"StudioHome_page__wG6gb","head":"StudioHome_head__Zo94I"};